// This component is essentially just styles with no functionality, so safe to
// ignore for coverage
/* istanbul ignore file */

import { marginX, marginY } from "../../styles";
import styled, { css } from "styled-components";
const horizontalStyles = css`
  min-height: 1px;
  min-width: 100%;
  ${marginY.s}
`;
const verticalStyles = css`
  min-height: 100%;
  min-width: 1px;
  ${marginX.s}
`;
export const Divider = styled.div<{
  vertical?: boolean;
}>`
  background: ${({
  theme
}) => theme.brand.cssVars["--d-border"]};
  ${({
  vertical
}) => vertical ? verticalStyles : horizontalStyles}
`;
export default Divider;